import { isBoundedRasterDataUrl } from './rasterImagePolicy.js';

// Shared screen/print URL policy. SVG and HTML remain outside the image path.
export function resolvePassageMedia(value) {
  const raw = String(value || '').trim();
  if (!raw) return { kind: 'none', src: '' };
  if (raw.startsWith('data:')) {
    if (!isBoundedRasterDataUrl(raw))
      return { kind: 'invalid', src: '' };
    return { kind: 'image', src: raw };
  }
  if (raw.length > 4096 || raw.startsWith('//') || /[\u0000-\u0020<>"'\\]/.test(raw)) return { kind: 'invalid', src: '' };
  const animation = raw.startsWith('animation:') || /\.html$/i.test(raw);
  if (animation) {
    const path = raw.replace(/^animation:/, '').replace(/^\//, '');
    return /^[a-z0-9_./-]+$/i.test(path) && !path.includes('..')
      ? { kind: 'animation', src: `/api/animation/${path}` } : { kind: 'invalid', src: '' };
  }
  if (/^https?:\/\//i.test(raw)) {
    try {
      const url = new URL(raw);
      return !url.username && !url.password ? { kind: 'image', src: raw } : { kind: 'invalid', src: '' };
    } catch { return { kind: 'invalid', src: '' }; }
  }
  let decoded;
  try { decoded = decodeURIComponent(raw); } catch { return { kind: 'invalid', src: '' }; }
  if (!/^(?:\/(?!\/))?[a-z0-9_./%~-]+(?:\?[a-z0-9_.=&%~-]+)?$/i.test(raw)
      || decoded.startsWith('//') || decoded.includes('..') || /[\u0000-\u001f\u007f<>"'\\]/.test(decoded)) return { kind: 'invalid', src: '' };
  return { kind: 'image', src: raw.startsWith('/') ? raw : `/${raw}` };
}

export function passageImageUrl(value) {
  const media = resolvePassageMedia(value);
  return media.kind === 'image' ? media.src : '';
}
